import notifySound from '../../assets/sounds/notify.mp3'
import logoConexa from '../../assets/logo-conexa.svg'

export const initializeBrowserNotification = (): void => {
  if (!window.Notification || !Notification.requestPermission) {
    console.log('Esse browser não suporta notificações desktop')
    return
  }

  if (Notification.permission !== 'denied') {
    Notification.requestPermission()
  }
}

export const notify = (title: string, content: string, img?: string): void => {
  if (!window.Notification || !Notification.requestPermission) return

  if (Notification.permission === 'granted') {
    navigator.serviceWorker.ready.then(registration => {
      registration.showNotification(title, {
        body: content,
        icon: img || logoConexa,
      })

      const sound = new Audio(notifySound)
      sound.play().catch(e => console.log(e))

      registration.getNotifications().then(notifications => {
        if (notifications.length > 0) {
          notifications.forEach(notification => {
            notification.onclick = e => {
              e.preventDefault()
              window.focus()
              notification.close()
            }
          })
        }
      })
    })
  }
}
